import React, { useState, useEffect } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Button, LinearProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import toast from 'react-hot-toast';
import { Autocomplete } from '@mui/material';
import LeadService from '../../core/services/leadsService';

const PromoAddMessage = ({ GetAllPrompts }) => {
    const [createMessage, setCreateMessage] = useState('');
    const [PromptType, setPromptType] = useState('');
    const [userType, setUserType] = useState('');
    const [open, setOpen] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setPromptType('');
        setCreateMessage('');
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const options = [
        { label: 'Motivational', value: 'motivational' },
        { label: 'Feature', value: 'feature' },
    ];
    const optionsUser = [
        { label: 'Agent', value: 'agent' },
        { label: 'Customer', value: 'customer' },
    ];

    const handleSaveChange = async () => {
        if (!createMessage) {
            return toast.error('Promo message is required');
        }

        if (!PromptType) {
            return toast.error('Please select a Prompts type');
        }
        if (!userType) {
            return toast.error('Please select a User type');
        }
        try {
            setLoading(true);
            const res = await LeadService.AddPromptMessage(createMessage, PromptType, userType);
            if (res.data.success) {
                toast.success(res.data.message);
                GetAllPrompts();
                setPromptType('');
                setUserType('');
                setCreateMessage('');
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
            setOpen(false);
        }
    };

    const HandleChangePromptsType = (event, newValue) => {
        setPromptType(newValue?.value);
    };
    const filteredOptions =
        userType === "customer"
            ? options.filter((option) => option.value === "motivational")
            : options;
    const HandleChangeUserType = (event, newValue) => {
        setUserType(newValue?.value);
    };

    const handleChange = (event) => {
        const value = event.target.value;
        if (value.length <= 255) {
            setCreateMessage(value);
            setError(false);
        } else {
            setError(true);
        }
    };
    return (
        <div>
            <Button
                onClick={handleOpen}
                variant="contained"
                className='main-primary-btn'
                startIcon={<AddIcon style={{ fontSize: '18px' }} />}
            >
                Add
            </Button>
            <Modal open={open}>
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '558px',
                        height: 'auto',
                    }}
                    className="modal-resp-settings"
                >
                    <Box style={{ display: 'flex' }}>
                        <Typography
                            style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700',
                            }}
                        >
                            Add Promo Message
                        </Typography>
                    </Box>
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box className="w-100">
                        <Box style={{ display: 'grid', gap: '10px', marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                id="message"
                                name="message"
                                // label="Message"
                                placeholder='write message ...'
                                multiline
                                rows={3}
                                value={createMessage}
                                sx={{
                                    marginTop: '15px',
                                    width: '100%',
                                    minHeight: '200px', // Ensure minimum height
                                    overflowY: 'auto',
                                    '& .MuiInputBase-input': {
                                        minHeight: '60px', // Apply minimum height to the input area

                                    }, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                                onChange={handleChange}
                                inputProps={{
                                    maxLength: 256,
                                }}
                                error={error}
                                helperText={error ? 'Character limit exceeded! Maximum 255 characters allowed.' : ''}

                            />

                            <Typography variant="body2" color={error ? 'error' : 'textSecondary'}>
                                {`${createMessage.length}/255 characters`}
                            </Typography>

                            <Autocomplete
                                options={optionsUser}
                                getOptionLabel={(optionsUser) => optionsUser.label}
                                renderInput={(params) => <TextField {...params} label="User Type" />}
                                value={optionsUser.find((optionsUser) => optionsUser.value === userType) || null}
                                onChange={HandleChangeUserType}
                                sx={{
                                    marginTop: '15px',
                                    width: '100%', '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                            <Autocomplete
                                options={filteredOptions}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField {...params} label="Prompts Type" />
                                )}
                                value={
                                    filteredOptions.find((option) => option.value === PromptType) || null
                                }
                                onChange={HandleChangePromptsType}
                                sx={{
                                    marginTop: '15px',
                                    width: '100%',
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "12px",
                                    },
                                }}
                            />

                        </Box>
                        <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Box>
                                <Button
                                    onClick={handleSaveChange}
                                    style={{
                                        width: '148px',
                                        height: '43px',
                                        backgroundColor: '#5379BD',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textTransform: 'capitalize',
                                        fontSize: 'auto',
                                    }}
                                    sx={{ fontFamily: 'inherit', }}
                                    disabled={Loading}
                                >
                                    {' '}
                                    {Loading ? 'Saving...' : 'Save'}
                                </Button>
                                <LinearProgress sx={{ visibility: Loading ? '' : 'hidden' }} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default PromoAddMessage;
